import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import no from './locales/no';


i18n
  .use(LanguageDetector)
  .init({
    resources: {
      'nb-NO': {
        translations: no
      },
    },
    fallbackLng: 'nb-NO',
    debug: true,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false,

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },

    react: {
      wait: true
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js